import { defineComponent as N, useSlots as w, computed as t, useAttrs as B, openBlock as d, createElementBlock as i, normalizeClass as u, createElementVNode as x, mergeProps as T, renderSlot as z, createVNode as E, unref as S } from "vue";
import { usePropsValidation as _ } from "../../composables/usePropsValidation.js";
import $ from "../../icons/generated/IconCheckLarge.vue2.js";
import { omit as j } from "../../utils/omit.js";
import { tw as a } from "../../utils/tailwind.js";
import { CHANGE_EVENT as P } from "./CheckboxBase.constant.js";
const W = ["id", "checked", "disabled", "value"], R = /* @__PURE__ */ N({
  name: "RevCheckboxBase",
  inheritAttrs: !1,
  __name: "CheckboxBase",
  props: {
    modelValue: { type: [Boolean, Array], default: !1 },
    disabled: { type: Boolean, default: !1 },
    isTransparent: { type: Boolean, default: !1 },
    id: {},
    label: {},
    value: { default: "on" },
    tickClassNames: { type: [String, Boolean, Array, Object], default: a`left-0 top-2` }
  },
  emits: ["change", "update:modelValue"],
  setup(o, { emit: p }) {
    const e = o, b = w(), r = p, c = t(() => !!b.default), s = t(() => !c.value), m = t({
      get() {
        return e.value && Array.isArray(e.modelValue) ? e.modelValue.includes(e.value) : e.modelValue;
      },
      set(l) {
        l !== e.modelValue && r("update:modelValue", l);
      }
    });
    function v(l) {
      if (r(P, l), typeof e.modelValue == "boolean") {
        r("update:modelValue", l.target.checked);
        return;
      }
      if (Array.isArray(e.modelValue)) {
        const n = l.target.checked ? [...e.modelValue, e.value] : e.modelValue.filter((A) => A !== e.value), g = Array.from(new Set(n));
        r("update:modelValue", g);
      }
    }
    _({
      "If no slot is passed, `props.label` is mandatory": () => s.value && !e.label
    });
    const h = t(() => {
      const l = B();
      return {
        ...j(l, ["class"]),
        ...s.value && e.label && {
          "aria-label": e.label
        }
      };
    }), k = t(() => [
      a`relative`,
      s.value && a`size-24`
    ]), y = t(() => [
      a`peer appearance-none outline-none`,
      c.value && a`sr-only`,
      s.value && a`absolute inset-x-0 bottom-0 top-2 size-20`,
      s.value && !e.disabled && a`cursor-pointer`,
      s.value && e.disabled && a`cursor-not-allowed`
    ]), f = t(() => [
      a`rounded-sm pointer-events-none absolute flex size-20 shrink-0 items-center justify-center`,
      e.disabled && a`bg-action-default-low-disabled`,
      s.value && "left-0 top-2 peer-focus-visible:outline-default-hi",
      e.tickClassNames
    ]), C = t(() => [
      a`border`,
      e.isTransparent ? a`bg-transparent` : a`bg-action-default-low`,
      !e.isTransparent && !e.disabled && a`peer-hover:bg-action-default-low-hover`,
      e.disabled ? a`border-action-default-hi-disabled` : a`border-action-default-hi`
    ]), V = t(() => [
      a`border border-transparent`,
      e.disabled ? a`text-onaction-default-low-disabled` : a`bg-action-default-low-pressed text-onaction-default-low-pressed peer-hover:bg-action-default-low-hoverpressed`
    ]);
    return (l, n) => (d(), i("div", {
      class: u([l.$attrs.class, k.value])
    }, [
      x("input", T({ id: o.id }, h.value, {
        checked: m.value,
        class: y.value,
        disabled: o.disabled,
        type: "checkbox",
        value: o.value,
        onChange: v
      }), null, 16, W),
      z(l.$slots, "default"),
      m.value ? (d(), i("div", {
        key: 0,
        class: u([f.value, V.value])
      }, [
        E(S($), {
          class: "motion-safe:animate-[fade_10ms_ease-in]",
          size: "16"
        })
      ], 2)) : (d(), i("div", {
        key: 1,
        class: u([f.value, C.value])
      }, null, 2))
    ], 2));
  }
});
export {
  R as default
};
